import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, onBeforeMount, watch } from 'vue';
import { useRepositories } from '@/plugins/repositories';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var gridRef = ref(null);
    var contentRefs = ref([]);
    var categories = ref([]);
    var $repositories = useRepositories();
    var $telemetry = useTelemetry();
    var route = useRoute();
    var auth = useAuth();
    var router = useRouter();
    function resizeGridItem(item) {
      var _item$querySelector, _item$querySelector$g;
      if (gridRef.value === null) {
        console.debug('gridRef is null. skip resizeGridItem');
        return;
      }
      var rowHeight = parseInt(window.getComputedStyle(gridRef.value).getPropertyValue('grid-auto-rows'));
      var rowGap = parseInt(window.getComputedStyle(gridRef.value).getPropertyValue('grid-row-gap'));
      var rowSpan = Math.ceil(((((_item$querySelector = item.querySelector('.category')) === null || _item$querySelector === void 0 ? void 0 : (_item$querySelector$g = _item$querySelector.getBoundingClientRect()) === null || _item$querySelector$g === void 0 ? void 0 : _item$querySelector$g.height) || 0) + rowGap) / (rowHeight + rowGap));
      item.style.gridRowEnd = "span ".concat(rowSpan);
    }
    function resizeAllGridItems() {
      if (contentRefs.value.length === 0) {
        console.debug('gridRef is null. skip resizeAllGridItems');
        return;
      }
      contentRefs.value.forEach(resizeGridItem);
    }
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (auth.permissions.formatDownload) {
              _context.next = 3;
              break;
            }
            router.push('/');
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return $repositories.format.getCategories();
          case 5:
            categories.value = _context.sent;
            window.addEventListener('resize', resizeAllGridItems);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    watch(contentRefs, function () {
      resizeAllGridItems();
    });
    function onClickLink(category, subcategory) {
      $telemetry.sendClickTelemetry({
        button: 'format-categories__subcategory',
        params: {
          format: {
            categories: {
              category: category,
              subcategory: subcategory
            }
          }
        }
      }, route);
    }
    return {
      __sfc: true,
      gridRef: gridRef,
      contentRefs: contentRefs,
      categories: categories,
      $repositories: $repositories,
      $telemetry: $telemetry,
      route: route,
      auth: auth,
      router: router,
      resizeGridItem: resizeGridItem,
      resizeAllGridItems: resizeAllGridItems,
      onClickLink: onClickLink
    };
  }
});